export default "__VITE_ASSET__IbPDj$wU__"